export enum TemplateStatus {
    Any = -1,
    Approved = 0,
    Rejected = 1,
    InProcess = 2
};